import React from 'react';
import { useTranslation } from 'next-i18next';
import PropTypes from 'prop-types';

import Counter from '@spa/shared/components/Counter';
import { Wrapper } from './styles';
import Persons from '@spa/shared/svg/persons';
import { trackAmplitude } from '@spa/shared/hooks/tracking/services/amplitude/dataAmplitude';
import events from '@spa/shared/hooks/tracking/events';

const TenantCounter = ({ guests, maxGuests, setGuests }) => {
  const { t } = useTranslation();

  const handleUpdate = newValue => {
    trackAmplitude(events.extraGuestAdded, { newValue });
    setGuests(newValue);
  };

  return (
    <Wrapper>
      <Persons />
      {`${guests} ${t(guests > 1 ? 'people' : 'person')}`}
      <Counter min={1} max={maxGuests} value={guests} onUpdate={handleUpdate} />
    </Wrapper>
  );
};

TenantCounter.propTypes = {
  guests: PropTypes.number,
  maxGuests: PropTypes.number,
  setGuests: PropTypes.func
};

export default TenantCounter;
